import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Technologies.css';

const Technologies = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const technologies = [
    { icon: 'fab fa-react', name: 'React', color: '#61dafb' },
    { icon: 'fab fa-node-js', name: 'Node.js', color: '#339933' },
    { icon: 'fab fa-js-square', name: 'JavaScript', color: '#f7df1e' },
    { icon: 'fab fa-css3-alt', name: 'CSS3', color: '#1572b6' },
    { icon: 'fab fa-html5', name: 'HTML5', color: '#e34f26' },
    { icon: 'fab fa-android', name: 'Android', color: '#3ddc84' },
    { icon: 'fab fa-apple', name: 'iOS', color: '#000000' },
    { icon: 'fab fa-java', name: 'Java', color: '#007396' },
    { icon: 'fab fa-microsoft', name: '.NET', color: '#512bd4' },
    { icon: 'fas fa-database', name: 'SQL Server', color: '#cc2927' },
    { icon: 'fab fa-php', name: 'PHP', color: '#777bb4' },
    { icon: 'fas fa-code', name: 'C++', color: '#00599c' },
    { icon: 'fas fa-database', name: 'Oracle', color: '#f80000' },
    { icon: 'fas fa-network-wired', name: 'Network Management Tools', color: '#00a651' }
  ];

  return (
    <section id="technologies" className="technologies" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Technologies We Use</h2>
          <p>The stack we use to deliver websites, mobile apps, and business systems</p>
        </motion.div>

        <motion.div 
          className="tech-grid"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              className="tech-item"
              initial={{ opacity: 0, scale: 0.5 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ 
                duration: 0.5, 
                delay: 0.3 + index * 0.1,
                type: "spring",
                stiffness: 100
              }}
              whileHover={{ 
                scale: 1.05,
                y: -5,
                transition: { duration: 0.3 }
              }}
            >
              <i className={tech.icon} style={{ color: tech.color }}></i>
              <span>{tech.name}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Technologies;


